var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"storeInformation"}},[_c('div',{staticStyle:{"position":"relative","top":"0","left":"0"}},[_c('div',{style:({
        height: (_vm.phoneSearchHeight + "px")
      })})]),_vm._v(" "),_c('div',{staticStyle:{"padding":"5vh 5vw"}},[_c('Banner',{ref:"banner",staticClass:"banner",attrs:{"banner-cat-id":14}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b51a9e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/storeInformation.vue
// module id = null
// module chunks = 